import ChainIcon from './ChainIcon'

/** The words that go with the seal on the card: where it was verified. */
export default function CardAuthLegend({ chainId = 80002 }) {
  return (
    <span className="flex items-center gap-2.5 whitespace-nowrap text-[13px] uppercase tracking-[0.18em] text-white/80">
      Verified on
      <span className="inline-flex items-center gap-1.5 text-white">
        <ChainIcon chainId={chainId} className="h-4 w-4" />
        Polygon
      </span>
    </span>
  )
}
